<template>
  <div class="container" style="background: linear-gradient(225.37deg, #ebf5fe 23.1%, rgba(235, 245, 254, 0) 107.52%)">
    <h2 class="heading">{{ $t('browser.banner.heading') }}</h2>
    <p class="para">{{ $t('browser.banner.para') }}</p>

    <div class="browser">
      <span>
        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_87_59542)">
            <path
              d="M20.4784 30.7268C26.1079 30.7268 30.6723 26.1631 30.6723 20.5328C30.6723 14.9025 26.1087 10.3389 20.4784 10.3389C14.8481 10.3389 10.2844 14.9025 10.2844 20.5328C10.2844 26.1631 14.8481 30.7268 20.4784 30.7268Z"
              fill="white"
            />
            <path
              d="M11.6498 25.6315L2.82357 10.3438C1.03383 13.4428 0.0913086 16.9582 0.0913086 20.5369C0.0913086 24.1156 1.03303 27.631 2.82277 30.73C4.61252 33.8291 7.18623 36.402 10.2861 38.1909C13.3859 39.9799 16.9013 40.9208 20.48 40.92L29.3062 25.6315V25.6291C28.4125 27.1794 27.1257 28.467 25.5762 29.3623C24.0267 30.2576 22.2689 30.7292 20.4792 30.7292C18.6895 30.7292 16.9317 30.2584 15.3814 29.3639C13.8311 28.4694 12.5443 27.1818 11.6498 25.6315Z"
              fill="url(#paint0_linear_87_59542)"
            />
            <path
              d="M29.3054 25.6317L20.4792 40.9195C24.0579 40.9203 27.5733 39.9785 30.6724 38.1888C33.7714 36.3998 36.3451 33.8261 38.134 30.7271C39.923 27.6281 40.8647 24.1119 40.8639 20.5332C40.8631 16.9545 39.9206 13.439 38.13 10.3408H20.4776L20.4752 10.3424C22.265 10.3416 24.0235 10.8117 25.573 11.7062C27.1233 12.6006 28.4102 13.8875 29.3054 15.437C30.2007 16.9865 30.6716 18.745 30.6716 20.5348C30.6724 22.3237 30.2007 24.0814 29.3054 25.6317Z"
              fill="url(#paint1_linear_87_59542)"
            />
            <path
              d="M20.4784 28.6044C24.9355 28.6044 28.5486 24.9913 28.5486 20.5341C28.5486 16.077 24.9355 12.4639 20.4784 12.4639C16.0212 12.4639 12.4081 16.077 12.4081 20.5341C12.4081 24.9913 16.0212 28.6044 20.4784 28.6044Z"
              fill="#1A73E8"
            />
            <path
              d="M20.4784 10.3414H38.1317C36.3427 7.24158 33.769 4.66787 30.67 2.87893C27.571 1.08918 24.0555 0.147461 20.4768 0.147461C16.8981 0.147461 13.3827 1.08998 10.2837 2.87973C7.18466 4.66947 4.61175 7.24398 2.82361 10.343L11.6498 25.6315L11.6522 25.6331C10.7569 24.0836 10.2845 22.3259 10.2845 20.5362C10.2845 18.7464 10.7545 16.9879 11.649 15.4384C12.5435 13.8881 13.8303 12.6012 15.3807 11.7067C16.9302 10.8115 18.6887 10.3406 20.4784 10.3414Z"
              fill="url(#paint2_linear_87_59542)"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_87_59542"
              x1="22.685"
              y1="39.6467"
              x2="5.03104"
              y2="9.06912"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1E8E3E" />
              <stop offset="1" stop-color="#34A853" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_87_59542"
              x1="17.5043"
              y1="40.9736"
              x2="35.1583"
              y2="10.3961"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FCC934" />
              <stop offset="1" stop-color="#FBBC04" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_87_59542"
              x1="2.8235"
              y1="12.8903"
              x2="38.1314"
              y2="12.8903"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#D93025" />
              <stop offset="1" stop-color="#EA4335" />
            </linearGradient>
            <clipPath id="clip0_87_59542">
              <rect width="41" height="41" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>

      <span>
        <svg width="44" height="41" viewBox="0 0 44 41" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M40.0726 13.4189C39.225 11.392 37.5056 9.20366 36.1592 8.51188C37.1195 10.3602 37.786 12.3452 38.1348 14.3963L38.1383 14.4288C35.9327 8.96356 32.1925 6.76068 29.1379 1.96275C28.9801 1.71815 28.8269 1.47068 28.6783 1.22045C28.6017 1.08975 28.5301 0.956267 28.4634 0.820287C28.3367 0.576466 28.2391 0.318788 28.1725 0.0524784C28.1726 0.0401895 28.1681 0.028298 28.1599 0.0190724C28.1518 0.00984673 28.1405 0.00393262 28.1282 0.00245824C28.1162 -0.000819413 28.1035 -0.000819413 28.0915 0.00245824C28.0889 0.00245824 28.0849 0.00696005 28.0819 0.00746025L28.0678 0.0154635L28.0753 0.00245824C23.1755 2.85361 21.513 8.13173 21.36 10.7718C19.4033 10.9053 17.5325 11.6217 15.9916 12.8276C15.8308 12.6925 15.6628 12.5661 15.4882 12.449C15.0438 10.9028 15.0248 9.26647 15.4334 7.71056C13.634 8.57687 12.0351 9.80492 10.7379 11.317H10.7288C9.95572 10.3431 10.0101 7.13183 10.0544 6.46106C9.82566 6.5524 9.60734 6.66759 9.40307 6.8047C8.72058 7.28877 8.08256 7.83194 7.49648 8.42785C6.82862 9.10078 6.21864 9.82811 5.67294 10.6022V10.6052V10.6017C4.41878 12.3687 3.52924 14.3651 3.05566 16.4756L3.02949 16.6036C2.95754 17.0058 2.8936 17.4094 2.83772 17.8141C2.83772 17.8286 2.8347 17.8421 2.83319 17.8566C2.66243 18.7387 2.55662 19.6319 2.5166 20.5292V20.6293C2.52088 25.4834 4.35727 30.1593 7.66284 33.7329C10.9684 37.3065 15.5026 39.5177 20.3694 39.9297C25.2362 40.3416 30.0814 38.9242 33.9474 35.9576C37.8135 32.991 40.4191 28.691 41.2493 23.9076C41.282 23.6575 41.3087 23.4099 41.3379 23.1573C41.7398 19.8569 41.3048 16.509 40.0726 13.4184V13.4189ZM17.5891 28.594C17.6802 28.6375 17.7658 28.684 17.8594 28.726L17.873 28.7345C17.7784 28.6895 17.6837 28.6427 17.5891 28.594ZM38.1398 14.4333V14.4148L38.1433 14.4348L38.1398 14.4333Z"
            fill="url(#paint0_linear_87_59543)"
          />
          <path
            d="M40.0726 13.4187C39.225 11.3919 37.5056 9.2035 36.1592 8.51172C37.1195 10.36 37.786 12.345 38.1348 14.3961V14.4146L38.1383 14.4346C39.642 18.7107 39.4245 23.3989 37.5313 27.5194C35.2955 32.2863 29.8838 37.1733 21.4129 36.9357C12.2599 36.6781 4.19921 29.9278 2.69226 21.0878C2.41795 19.6937 2.69226 18.9869 2.83017 17.854C2.64204 18.734 2.53706 19.6296 2.5166 20.5291V20.6291C2.52088 25.4832 4.35727 30.1591 7.66284 33.7327C10.9684 37.3063 15.5026 39.5176 20.3694 39.9295C25.2362 40.3414 30.0814 38.924 33.9474 35.9574C37.8135 32.9908 40.4191 28.6909 41.2493 23.9074C41.282 23.6573 41.3087 23.4097 41.3379 23.1571C41.7398 19.8567 41.3048 16.5089 40.0726 13.4182V13.4187Z"
            fill="url(#paint1_radial_87_59543)"
          />
          <path
            d="M40.0726 13.4187C39.225 11.3919 37.5056 9.2035 36.1592 8.51172C37.1195 10.36 37.786 12.345 38.1348 14.3961V14.4146L38.1383 14.4346C39.642 18.7107 39.4245 23.3989 37.5313 27.5194C35.2955 32.2863 29.8838 37.1733 21.4129 36.9357C12.2599 36.6781 4.19921 29.9278 2.69226 21.0878C2.41795 19.6937 2.69226 18.9869 2.83017 17.854C2.64204 18.734 2.53706 19.6296 2.5166 20.5291V20.6291C2.52088 25.4832 4.35727 30.1591 7.66284 33.7327C10.9684 37.3063 15.5026 39.5176 20.3694 39.9295C25.2362 40.3414 30.0814 38.924 33.9474 35.9574C37.8135 32.9908 40.4191 28.6909 41.2493 23.9074C41.282 23.6573 41.3087 23.4097 41.3379 23.1571C41.7398 19.8567 41.3048 16.5089 40.0726 13.4182V13.4187Z"
            fill="url(#paint2_radial_87_59543)"
          />
          <path
            d="M30.5929 15.6982C30.6352 15.7278 30.6745 15.7573 30.7142 15.7868C30.2242 14.9233 29.6143 14.1327 28.9023 13.4383C22.8393 7.41191 27.3133 0.371578 28.0678 0.0139341L28.0753 0.00292969C23.1755 2.85408 21.513 8.1322 21.36 10.7723C21.5875 10.7568 21.813 10.7372 22.0455 10.7372C23.7841 10.7405 25.4909 11.2012 26.9922 12.0726C28.4935 12.944 29.7359 14.1949 30.5929 15.6982Z"
            fill="url(#paint3_radial_87_59543)"
          />
          <path
            d="M22.0581 16.9013C22.0259 17.3835 20.3116 19.0466 19.7121 19.0466C14.165 19.0466 13.2645 22.3815 13.2645 22.3815C13.5101 25.1896 15.4791 27.5026 17.8594 28.726C17.9681 28.7821 18.0783 28.8326 18.1885 28.8821C18.3795 28.9661 18.5704 29.0438 18.7613 29.1152C19.5782 29.4025 20.4338 29.5666 21.2996 29.6019C31.0223 30.0551 32.9057 18.0472 25.8894 14.5628C27.5446 14.3488 29.2208 14.7533 30.5929 15.6978C29.7358 14.1946 28.4934 12.9437 26.9921 12.0724C25.4908 11.2011 23.7841 10.7405 22.0455 10.7373C21.814 10.7373 21.5875 10.7563 21.36 10.7718C19.4033 10.9053 17.5324 11.6218 15.9915 12.8276C16.289 13.0777 16.6247 13.4124 17.3319 14.1052C18.6556 15.4007 22.0505 16.7437 22.0581 16.9013Z"
            fill="url(#paint4_radial_87_59543)"
          />
          <path
            d="M22.0581 16.9013C22.0259 17.3835 20.3116 19.0466 19.7121 19.0466C14.165 19.0466 13.2645 22.3815 13.2645 22.3815C13.5101 25.1896 15.4791 27.5026 17.8594 28.726C17.9681 28.7821 18.0783 28.8326 18.1885 28.8821C18.3795 28.9661 18.5704 29.0438 18.7613 29.1152C19.5782 29.4025 20.4338 29.5666 21.2996 29.6019C31.0223 30.0551 32.9057 18.0472 25.8894 14.5628C27.5446 14.3488 29.2208 14.7533 30.5929 15.6978C29.7358 14.1946 28.4934 12.9437 26.9921 12.0724C25.4908 11.2011 23.7841 10.7405 22.0455 10.7373C21.814 10.7373 21.5875 10.7563 21.36 10.7718C19.4033 10.9053 17.5324 11.6218 15.9915 12.8276C16.289 13.0777 16.6247 13.4124 17.3319 14.1052C18.6556 15.4007 22.0505 16.7437 22.0581 16.9013Z"
            fill="url(#paint5_radial_87_59543)"
          />
          <path
            d="M15.0821 12.1837C15.2401 12.2838 15.3705 12.3708 15.4847 12.4488C15.0403 10.9028 15.0214 9.26669 15.4299 7.71094C13.6305 8.57725 12.0316 9.8053 10.7344 11.3174C10.8295 11.3149 13.6592 11.2644 15.0821 12.1837Z"
            fill="url(#paint6_radial_87_59543)"
          />
          <path
            d="M2.69473 21.0877C4.20017 29.9283 12.2624 36.678 21.4153 36.9356C29.8863 37.1737 35.298 32.2867 37.5337 27.5193C39.4268 23.399 39.6443 18.711 38.1408 14.435V14.4165C38.1408 14.4015 38.1377 14.3935 38.1408 14.398L38.1443 14.4305C38.8363 18.9208 36.5382 23.2711 32.9455 26.2128L32.9344 26.2378C25.9342 31.9036 19.2349 29.6562 17.879 28.7388C17.7844 28.6938 17.6897 28.6469 17.5951 28.5982C13.5137 26.6594 11.8275 22.964 12.1889 19.7947C11.2201 19.8089 10.2679 19.5436 9.44769 19.0309C8.6275 18.5182 7.97454 17.7801 7.56791 16.906C8.63929 16.2537 9.8609 15.885 11.1163 15.8349C12.3718 15.7848 13.6192 16.0551 14.7398 16.6199C17.0499 17.6622 19.6787 17.7648 22.0641 16.906C22.0566 16.7485 18.6616 15.4054 17.3379 14.1099C16.6307 13.4171 16.295 13.0835 15.9976 12.8329C15.8368 12.6976 15.6688 12.571 15.4942 12.4537C15.3785 12.3752 15.2481 12.2902 15.0916 12.1881C13.6687 11.2688 10.839 11.3193 10.7454 11.3218H10.7363C9.96322 10.3479 10.0176 7.13659 10.0619 6.46582C9.83316 6.55717 9.61484 6.67236 9.41057 6.80946C8.72809 7.29353 8.09007 7.8367 7.50398 8.43261C6.83373 9.10365 6.22123 9.82931 5.67289 10.602V10.605V10.6015C4.41873 12.3685 3.52919 14.3648 3.05561 16.4753C3.04605 16.5149 2.35297 19.5261 2.69473 21.0872V21.0877Z"
            fill="url(#paint7_radial_87_59543)"
          />
          <path
            d="M28.9033 13.4379C29.6155 14.133 30.2254 14.9244 30.7153 15.7888C30.8225 15.8688 30.9226 15.9489 31.0077 16.0269C35.4304 20.0785 33.1131 25.8058 32.9404 26.2135C36.5332 23.2718 38.8293 18.9216 38.1393 14.4313C35.9327 8.96356 32.1925 6.76068 29.1378 1.96275C28.9801 1.71815 28.8269 1.47068 28.6783 1.22045C28.6017 1.08975 28.53 0.956267 28.4634 0.820287C28.3367 0.576466 28.2391 0.318788 28.1725 0.0524784C28.1726 0.0401895 28.1681 0.028298 28.1599 0.0190724C28.1518 0.00984673 28.1404 0.00393262 28.1282 0.00245824C28.1161 -0.000819413 28.1035 -0.000819413 28.0914 0.00245824C28.0889 0.00245824 28.0849 0.00696005 28.0819 0.00746025L28.0678 0.0154635C27.3133 0.370606 22.8393 7.41144 28.9033 13.4379Z"
            fill="url(#paint8_radial_87_59543)"
          />
          <path
            d="M31.0047 16.0248C30.911 15.941 30.8134 15.8615 30.7123 15.7867C30.6725 15.7567 30.6333 15.7277 30.591 15.6982C29.2189 14.7535 27.5427 14.3488 25.8874 14.5627C32.9038 18.0491 31.0213 30.0555 21.2976 29.6023C20.4318 29.5669 19.5763 29.4029 18.7594 29.1156C18.5684 29.0445 18.3775 28.9669 18.1866 28.8825C18.0764 28.8325 17.9661 28.7824 17.8574 28.7264L17.871 28.7349C19.227 29.6548 25.9242 31.9022 32.9264 26.2339L32.9375 26.2089C33.1121 25.8037 35.4294 20.0749 31.0047 16.0248Z"
            fill="url(#paint9_radial_87_59543)"
          />
          <path
            d="M13.2645 22.3814C13.2645 22.3814 14.165 19.0466 19.7121 19.0466C20.3116 19.0466 22.0274 17.3834 22.0581 16.9007C19.6728 17.7597 17.044 17.6572 14.7337 16.6151C13.6132 16.0503 12.3658 15.78 11.1103 15.8301C9.85489 15.8802 8.63327 16.2489 7.56189 16.9012C7.96852 17.7753 8.62149 18.5134 9.44167 19.0261C10.2619 19.5388 11.2141 19.8041 12.1829 19.7899C11.8215 22.9597 13.5076 26.6552 17.5891 28.5934C17.6802 28.637 17.7658 28.6835 17.8594 28.7255C15.4771 27.5025 13.5102 25.1891 13.2645 22.3814Z"
            fill="url(#paint10_radial_87_59543)"
          />
          <path
            d="M40.0726 13.4189C39.225 11.392 37.5056 9.20366 36.1592 8.51188C37.1195 10.3602 37.786 12.3452 38.1348 14.3963L38.1383 14.4288C35.9327 8.96356 32.1925 6.76068 29.1379 1.96275C28.9801 1.71815 28.8269 1.47068 28.6783 1.22045C28.6017 1.08975 28.5301 0.956267 28.4634 0.820287C28.3367 0.576466 28.2391 0.318788 28.1725 0.0524784C28.1726 0.0401895 28.1681 0.028298 28.1599 0.0190724C28.1518 0.00984673 28.1405 0.00393262 28.1282 0.00245824C28.1162 -0.000819413 28.1035 -0.000819413 28.0915 0.00245824C28.0889 0.00245824 28.0849 0.00696005 28.0819 0.00746025L28.0678 0.0154635L28.0753 0.00245824C23.1755 2.85361 21.513 8.13173 21.36 10.7718C21.5875 10.7563 21.813 10.7368 22.0455 10.7368C23.7842 10.74 25.4909 11.2007 26.9922 12.0721C28.4936 12.9435 29.7359 14.1944 30.593 15.6978C29.2209 14.7531 27.5447 14.3484 25.8894 14.5623C32.9057 18.0487 31.0233 30.0551 21.2996 29.6019C20.4338 29.5665 19.5782 29.4025 18.7614 29.1152C18.5704 29.0441 18.3795 28.9664 18.1886 28.8821C18.0783 28.8321 17.9681 28.782 17.8594 28.726L17.873 28.7345C17.7784 28.6895 17.6837 28.6427 17.5891 28.594C17.6802 28.6375 17.7658 28.684 17.8594 28.726C15.4772 27.5025 13.5102 25.1896 13.2646 22.3815C13.2646 22.3815 14.165 19.0466 19.7121 19.0466C20.3116 19.0466 22.0274 17.3835 22.0581 16.9008C22.0506 16.7437 18.6557 15.4002 17.3319 14.1046C16.6247 13.4124 16.289 13.0787 15.9916 12.8281C15.8308 12.6928 15.6628 12.5662 15.4882 12.449C15.0438 10.9028 15.0248 9.26647 15.4334 7.71056C13.634 8.57687 12.0351 9.80492 10.7379 11.317H10.7288C9.95572 10.3431 10.0101 7.13183 10.0544 6.46106C9.82566 6.5524 9.60734 6.66759 9.40307 6.8047C8.72058 7.28877 8.08256 7.83194 7.49648 8.42785C6.82862 9.10078 6.21864 9.82811 5.67294 10.6022V10.6052V10.6017C4.41878 12.3687 3.52924 14.3651 3.05566 16.4756L3.02949 16.6036C2.99275 16.7737 2.82816 17.6406 2.8045 17.8266C2.8045 17.8406 2.8045 17.8116 2.8045 17.8266C2.65396 18.7209 2.55782 19.6234 2.5166 20.5292V20.6293C2.52088 25.4834 4.35727 30.1593 7.66284 33.7329C10.9684 37.3065 15.5026 39.5177 20.3694 39.9297C25.2362 40.3416 30.0814 38.9242 33.9474 35.9576C37.8135 32.991 40.4191 28.691 41.2493 23.9076C41.282 23.6575 41.3087 23.4099 41.3379 23.1573C41.7398 19.8569 41.3048 16.509 40.0726 13.4184V13.4189ZM38.1373 14.4143L38.1408 14.4353L38.1373 14.4143Z"
            fill="url(#paint11_linear_87_59543)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_87_59543"
              x1="37.4905"
              y1="6.19695"
              x2="5.3015"
              y2="37.4471"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.048" stop-color="#FFF44F" />
              <stop offset="0.111" stop-color="#FFE847" />
              <stop offset="0.225" stop-color="#FFC830" />
              <stop offset="0.368" stop-color="#FF980E" />
              <stop offset="0.401" stop-color="#FF8B16" />
              <stop offset="0.462" stop-color="#FF672A" />
              <stop offset="0.534" stop-color="#FF3647" />
              <stop offset="0.705" stop-color="#E31587" />
            </linearGradient>
            <radialGradient
              id="paint1_radial_87_59543"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(35.9941 4.43908) scale(40.667 40.4148)"
            >
              <stop offset="0.129" stop-color="#FFBD4F" />
              <stop offset="0.186" stop-color="#FFAC31" />
              <stop offset="0.247" stop-color="#FF9D17" />
              <stop offset="0.283" stop-color="#FF980E" />
              <stop offset="0.403" stop-color="#FF563B" />
              <stop offset="0.467" stop-color="#FF3750" />
              <stop offset="0.71" stop-color="#F5156C" />
              <stop offset="0.782" stop-color="#EB0878" />
              <stop offset="0.86" stop-color="#E50080" />
            </radialGradient>
            <radialGradient
              id="paint2_radial_87_59543"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(21.134 20.9617) scale(40.667 40.4148)"
            >
              <stop offset="0.3" stop-color="#960E18" />
              <stop offset="0.351" stop-color="#B11927" stop-opacity="0.74" />
              <stop offset="0.435" stop-color="#DB293D" stop-opacity="0.343" />
              <stop offset="0.497" stop-color="#F5334B" stop-opacity="0.094" />
              <stop offset="0.53" stop-color="#FF3750" stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint3_radial_87_59543"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(26.0369 -4.73198) scale(29.4615 29.2788)"
            >
              <stop offset="0.132" stop-color="#FFF44F" />
              <stop offset="0.252" stop-color="#FFDC3E" />
              <stop offset="0.506" stop-color="#FF9D12" />
              <stop offset="0.526" stop-color="#FF980E" />
            </radialGradient>
            <radialGradient
              id="paint4_radial_87_59543"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(16.6358 31.5187) scale(19.3633 19.2432)"
            >
              <stop offset="0.353" stop-color="#3A8EE6" />
              <stop offset="0.472" stop-color="#5C79F0" />
              <stop offset="0.669" stop-color="#9059FF" />
              <stop offset="1" stop-color="#C139E6" />
            </radialGradient>
            <radialGradient
              id="paint5_radial_87_59543"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(23.3563 17.6498) rotate(-13.5104) scale(10.2628 11.9488)"
            >
              <stop offset="0.206" stop-color="#9059FF" stop-opacity="0" />
              <stop offset="0.278" stop-color="#8C4FF3" stop-opacity="0.064" />
              <stop offset="0.747" stop-color="#7716A8" stop-opacity="0.45" />
              <stop offset="0.975" stop-color="#6E008B" stop-opacity="0.6" />
            </radialGradient>
            <radialGradient
              id="paint6_radial_87_59543"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(20.6206 2.78596) scale(13.93 13.8436)"
            >
              <stop stop-color="#FFE226" />
              <stop offset="0.121" stop-color="#FFDB27" />
              <stop offset="0.295" stop-color="#FFC82A" />
              <stop offset="0.502" stop-color="#FFA930" />
              <stop offset="0.732" stop-color="#FF7E37" />
              <stop offset="0.792" stop-color="#FF7139" />
            </radialGradient>
            <radialGradient
              id="paint7_radial_87_59543"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(31.5699 -5.9952) scale(59.4329 59.0643)"
            >
              <stop offset="0.113" stop-color="#FFF44F" />
              <stop offset="0.456" stop-color="#FF980E" />
              <stop offset="0.622" stop-color="#FF5634" />
              <stop offset="0.716" stop-color="#FF3647" />
              <stop offset="0.904" stop-color="#E31587" />
            </radialGradient>
            <radialGradient
              id="paint8_radial_87_59543"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(26.5606 -2.71085) rotate(83.9387) scale(43.2926 28.5859)"
            >
              <stop stop-color="#FFF44F" />
              <stop offset="0.06" stop-color="#FFE847" />
              <stop offset="0.168" stop-color="#FFC830" />
              <stop offset="0.304" stop-color="#FF980E" />
              <stop offset="0.356" stop-color="#FF8B16" />
              <stop offset="0.455" stop-color="#FF672A" />
              <stop offset="0.57" stop-color="#FF3647" />
              <stop offset="0.737" stop-color="#E31587" />
            </radialGradient>
            <radialGradient
              id="paint9_radial_87_59543"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(20.2925 7.91354) scale(37.105 36.8748)"
            >
              <stop offset="0.137" stop-color="#FFF44F" />
              <stop offset="0.48" stop-color="#FF980E" />
              <stop offset="0.592" stop-color="#FF5634" />
              <stop offset="0.655" stop-color="#FF3647" />
              <stop offset="0.904" stop-color="#E31587" />
            </radialGradient>
            <radialGradient
              id="paint10_radial_87_59543"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(30.0871 10.0715) scale(40.6111 40.3592)"
            >
              <stop offset="0.094" stop-color="#FFF44F" />
              <stop offset="0.231" stop-color="#FFE141" />
              <stop offset="0.509" stop-color="#FFAF1E" />
              <stop offset="0.626" stop-color="#FF980E" />
            </radialGradient>
            <linearGradient
              id="paint11_linear_87_59543"
              x1="37.1014"
              y1="6.03089"
              x2="9.71794"
              y2="33.5848"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.167" stop-color="#FFF44F" stop-opacity="0.8" />
              <stop offset="0.266" stop-color="#FFF44F" stop-opacity="0.634" />
              <stop offset="0.489" stop-color="#FFF44F" stop-opacity="0.217" />
              <stop offset="0.6" stop-color="#FFF44F" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrowserBanner',
}
</script>

<style scoped>
.container {
  margin-top: 1rem;
  text-align: center;
  /* height: 119px; */
  padding: 16px;
  color: #2e2a26;
}

.heading {
  font-size: 14px;
  font-weight: bold;
}

.para {
  font-size: 14px;
  margin-top: 0rem;
  font-weight: 400 !important;
}

.browser {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: -1.25rem;
}
</style>
